export default __webpack_public_path__ + "images/btc_dbe6fa.svg";